import React from 'react';
import { Table, Button, Card, Modal, message, TreeSelect } from 'antd';
import common from '../../assets/common.js';
import MenuAction from '../../modest/menuaction/index.js';
import Edit from './edit.js'
import './index.css';
const SHOW_PARENT = TreeSelect.SHOW_PARENT;
class MemberTable extends React.Component {
  cancel = (id) =>{
    console.log(id)
  }
  constructor(){
    super();
    let table = {};
    table.id = "proTable";
    table = common.getDefaultTable(table);
    this.state = {
      table,
      search : "",
      visible: false,
      value: "",
      modalType : "",
      modalData : "",
      treeData: [],
      add: false,
      type: false,
      checkTable: []
    }
  }

  componentWillMount(){
    this.showTableCol();
    this.getArea();
    this.setCheckTableCol();
  }
  componentDidMount(){
    this.getList();
  }
  setCheckTableCol = () => {
    let table = this.state.checkTable;
    table.columns = [{
      title:'区域',
      dataIndex: 'areaName',
      key:'areaName'
    }, {
      title: '楼栋',
      dataIndex: 'building',
      key: 'building'
    }, {
      title: '单元门',
      dataIndex: "roomName",
      key: "roomName",
      width: '80px'
    }, {
      title: '姓名',
      dataIndex: "userName",
      key: "userName",
      width: '80px'
    }, {
      title: '学号',
      dataIndex: "cardNo",
      key: "cardNo",
      width: '120px'
    }, {
      title: '设备别名',
      dataIndex: 'doorName'
    }, {
      title: '状态',
      width: '80px',
      render: (text, record) => {
        return (
          <div>
            { record.status === "SUCCESS" && <span style={{ color: 'green' }}>成功</span>}
            { record.status === "FAIL" && <span style={{color: 'red'}}>失败</span>}
          </div>
        )
      }
    }];
    this.setState({
      checkTable: table
    });
  }
  showTableCol = () => {
    let table = this.state.table;
    table.columnsList = [{
      title: '时间',
      dataIndex: 'createTime',
      must: true,
      show: true,
      width: '190px',
      render: (text, record) => {
        return (
          <span>{ common.strToTime(record.createTime) }</span>
        )
      },
    }, {
      title: '操作类型',
      dataIndex: 'typeCode',
      must: false,
      show: true,
      render: (text, record) => {
        return (
          <span>{record.typeCode === "ADD"?"新增权限":"删除"}</span>
        )
      }
    }, {
      title: '状态',
      dataIndex: 'status',
      must: false,
      show: true,
      render: (text, record) => {
        const status = record.status;
        let span = "";
        switch (status) {
          case 'UNDER_WAY':
            span = "正在下发";
            break;
          case 'PART_FINISH':
            span = "部分完成";
            break;
          case 'FAIL':
            span = "下发失败";
            break;
          case 'FINISH':
            span = "完成";
            break;
          default:
        }
        return (
          <span>{span}</span>
        )
      }
    }, {
      title: '操作',
      dataIndex: 'userName',
      must: true,
      show: true,
      width : "120px",
      render: (text, record) => {
        return (
          <a onClick={ this.check.bind(this, "", record.serialId) }>查看详情</a>
        )
      }
    }];
    table = common.getEcardTable(table);
    this.setState({ table });
  }
  changePage = (pagination, filters, sorter) => {
    const table = this.state.table;
    table.pagination = pagination;
    this.setState({ table })
    this.getList(pagination.current);
  }
  getArea = () => {
    var postData = {};
    console.log(sessionStorage.getItem("subAdmin"))
    if(sessionStorage.getItem("subAdmin") === "true") {
      postData["_url"] = "api/admin/area";
    } else {
      postData["_url"] = "api/dc/access/area";
    }
    postData["_method"] = "GET";
    common.request(postData, this, function(obj, data) {
      let ar = data.result.subList.map(function(index){
        let arr1 = [];
        if(index.dcBuildingList.length !== 0) {
          let ar2 = index.dcBuildingList.map(function(item) {
            let arr2 = {};
            if(item.roomList.length !== 0) {
              let ar3 = item.roomList.map(function(dataItem) {
                let arr3 = {};
                arr3["title"] = dataItem.roomName;
                arr3["key"] = dataItem.roomId;
                arr3["value"] = dataItem.roomId;
                return arr3;
              })
              arr2["children"] = ar3;
            }
            arr2["title"] = item.building;
            arr2["key"] = item.buildingId;
            arr2["value"] = item.buildingId;
            return arr2;
          });
          arr1["children"] = ar2;
        }
        arr1["title"] = index.areaName;
        arr1["key"] = index.areaId;
        arr1["value"] = index.areaId;
        return arr1;
      });
      obj.setState({
        treeData: ar
      })
    }, function(obj, state) {

    })
  }
  // 下发记录
  getList = (pageInfo, filters, sorter) =>{
    const pn = pageInfo ? pageInfo : 1
    const batchId = this.state.batchId;
    const table = this.state.table;
    var postData = {};
    postData["_url"] = "api/whitelist/servial/search";
    postData["pageNum"] = pn;
    table.loading = true;
    this.setState({ table });
    common.request(postData, this, function(obj, data){
      const result = data.result;
      obj.showList(result, pn);
    },function(obj, state){
      table.loading = false;
      obj.setState({ table });
    });
  }
  showList = (result, pn) => {
    const table = this.state.table;
    const list = result.list;
    table.loading = false;
    var dataSource = [];
    table.pagination = {
      current : pn,
      total : result.pageInfo.resultAmount,
    }
    common.eachObj(list, function(index, dataItem){
      var one = dataItem;
      one["key"] = (index + 1);
      one["orgId"] = dataItem.orgId;
      one["orgName"]= dataItem.orgName;
      one["userName"] = dataItem.userName;
      dataSource.push(one);
    })
    table.dataSource = dataSource;
    this.setState({ table });
  }
  showModal = (modalType, modalData) => {
    switch(modalType){
      case "importend":
        this.getList();
        this.setState({ modalType, modalData });
        break;
      default:
        this.setState({ modalType, modalData });
        break;
    }
  }

  handleCancel = ()=> {
    this.setState({
      visible: false
    });
  }
  onChangeTree = (value) => {
    this.setState({ value });
  }
  addPower = () => {
    this.setState({
      add: true,
      type: false
    })
  }
  deletePower = () => {
    this.setState({
      add: true,
      type: true
    })
  }
  // 返回
  back = () => {
    this.setState({
      add: false
    })
  }
  handleCancelCheck = () => {
    this.setState({
      visible: false
    })
  }
  check = (pageInfo, id) => {
    if(id) {
      this.setState({
        id
      })
    } else {
      id = this.state.id;
    }
    const pn = pageInfo ?pageInfo: 1;
    const table = this.state.checkTable;
    let postData = {};
    postData["_url"] = 'api/whitelist/record/search';
    postData["serialId"] = id;
    postData["pageNum"] = pn;
    table.loading = true;
    this.setState({ checkTable: table });
    common.request(postData, this, function(obj, result){
      obj.setState({
        visible: true
      })
      obj.showCheckTable(result.result, pn);
    },function(obj, data){
      table.loading = false;
      this.setState({ checkTable: table });
      message.warning(data.message);
    });
  }
  showCheckTable = (result, pn) => {
    const table = this.state.checkTable;
    const list = result.list;
    table.loading = false;
    var dataSource = [];
    table.pagination = {
      current : pn,
      total : result.pageInfo.resultAmount,
    }
    common.eachObj(list, function(index, dataItem){
      var one = dataItem;
      one["key"] = (index + 1);
      dataSource.push(one);
    })
    table.dataSource = dataSource;
    this.setState({ checkTable: table});
  }
  changePageCheckTable = (pagination, filters, sorter) => {
    const table = this.state.checkTable;
    table.pagination = pagination;
    this.setState({ checkTable:table })
    this.check(pagination.current,"");
  }
  render(){
    const { table, modalType, modalData, add, type, modal, checkTable } = this.state;
    const tProps = {
      treeData: this.state.treeData,
      allowClear: true,
      value: this.state.value,
      onChange: this.onChangeTree,
      treeCheckable: true,
      showCheckedStrategy: SHOW_PARENT,
      searchPlaceholder: '请选择区域',
      style: {
        width: 300,
      },
    };
    console.log(this.props);
    return(
      <div>
        {!add && <div>
            <Card>
              <Button type="primary" className="mr-8" onClick={ this.addPower }>新增权限</Button>
              <Button type="primary" onClick={ this.deletePower }>删除权限</Button>
            </Card>
            <Card title="操作记录" style={{marginTop: 20}}>
              <div className="table-menu clearfix">
                <div className="pull-right">
                { table.show && <MenuAction obj={ this }/> }
                </div>
              </div>
              <div id="manageTableDiv" className="table-div">
                { table.show && <Table
                  { ...table }
                  onChange={this.changePage.bind(this)}
                />}
                <div className="table-total">共{ table.pagination.total }条数据</div>
              </div>
            </Card>
          </div>
        }
        { add && <Edit type={ type } back={ this.back }></Edit> }
        <Modal
          title="详情"
          visible={this.state.visible}
          centered={true}
          width = {800}
          className="text-center"
          onCancel={this.handleCancelCheck}
          onOk={this.handleCancelCheck}
        >
          <Table {...checkTable} onChange={this.changePageCheckTable.bind(this)}/>
        </Modal>
      </div>
    )
  }
}
export default MemberTable;



// WEBPACK FOOTER //
// ./src/component/power/add.js